import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assertSuccessfulWorkerResponse } from "./helpers";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePostParticipantRevertRevoke({
  callApiWithWorker,
  t,
  onErrorAlert,
}) {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["participants", "revert", "revoke"],
    mutationFn: async ({ participantId }) => {
      if (!participantId) throw new Error("Missing participantId");

      const res = await callApiWithWorker(
        `/registry/participants/${encodeURIComponent(participantId)}/revert/revoke`,
        {
          method: "POST",
          connector: "springConnector",
        },
      );

      return assertSuccessfulWorkerResponse(
        res,
        "Revert participant revocation failed",
      );
    },
    onSuccess: async (_data, vars) => {
      await qc.invalidateQueries({ queryKey: ["participants"] });
      await qc.invalidateQueries({
        queryKey: ["participants", "byId", vars?.participantId],
      });

      showSuccessToast(
        t?.(
          vars?.successMessageKey ?? "participant.approval.updated.reactivate",
          vars?.successMessageFallback ??
            "Participant reactivated successfully",
        ),
        {
          title: t?.("participant.approval.updatedTitle", "Approval updated"),
        },
      );
    },
    onError: async (err) => {
      if (onErrorAlert) return onErrorAlert(err);
      console.error(t ? t("error") : "Error", err);
    },
  });
}
